import { useEffect } from "react";

function isOpen(select: HTMLSelectElement) {
  try {
    return select.matches(":open");
  } catch {
    return false;
  }
}

/**
 * Normalizes behavior that the customizable native select leaves to browsers.
 * A second pointer press on the open trigger closes it without interfering with
 * pointer events originating from an option inside the picker.
 */
export function useGlobalSelectBehavior() {
  useEffect(() => {
    let lastTrigger: HTMLSelectElement | null = null;

    const handlePointerDown = (event: PointerEvent) => {
      const origin = event.composedPath()[0];
      if (!(origin instanceof HTMLSelectElement)) {
        lastTrigger = null;
        return;
      }

      if (lastTrigger === origin && isOpen(origin)) {
        event.preventDefault();
        origin.blur();
        lastTrigger = null;
        return;
      }

      lastTrigger = origin;
    };

    const reset = () => {
      lastTrigger = null;
    };

    document.addEventListener("pointerdown", handlePointerDown, true);
    document.addEventListener("change", reset, true);
    window.addEventListener("blur", reset);
    return () => {
      document.removeEventListener("pointerdown", handlePointerDown, true);
      document.removeEventListener("change", reset, true);
      window.removeEventListener("blur", reset);
    };
  }, []);
}
